import { produce } from 'immer';
import { EffectReducer } from 'use-effect-reducer';
import { EffectSingleDatePicker, EventSingleDatePicker, StateSingleDatePicker } from './types';
import { commmonReducer } from './commonReducer';

export const datepickerReducer: EffectReducer<
  StateSingleDatePicker,
  EventSingleDatePicker,
  EffectSingleDatePicker
> = (state, action, exec) =>
  produce<StateSingleDatePicker, StateSingleDatePicker>(state, (draft) => {
    switch (action.type) {
      case 'SET_DATE_ACTION':
        if (
          // TODO: remove activeTab check, not needed
          (draft.activeTab === 'exact' || draft.activeTab === 'flexible') &&
          state.monthsInterval?.startMonth === undefined &&
          state.tripDuration?.minimum === undefined
        ) {
          if (action.payload) {
            draft.preSelected = action.payload;
            draft.displayDate = action.payload;
            draft.currentDate = { start: action.payload, end: undefined };
          } else {
            draft.currentDate = { start: state.preSelected, end: undefined };
          }
          draft.focusSelectedDay = false;
          draft.valid = true;
        } else {
          // TODO: The flexible actions for keep trip duration and date range
        }

        exec(action);
        break;
      case 'SELECT_DAY_ACTION':
        if (!draft.enableFlexibleDates) {
          draft.currentDate = action.payload;
        }
        draft.preSelected = action.payload.start;
        draft.tripDuration = undefined;
        draft.monthsInterval = {};
        draft.valid = true;
        exec(action);
        break;
      case 'VALIDATE_DONE':
        draft.validateDone = !state.validateDone;
        break;
      default:
        commmonReducer(draft, action, exec);
    }
  });
